
import React from "react";
import { useState } from 'react';
import pageData from "../PageData";
import ChangePassword from "../Pages/ChangePassword";
const header =()=>{ 

//const [imgUrl,setImageUrl] = useState("/assets/images/usersImage/28.jpg");
//const [userName, setUserName] = useState("Naveen"); 
return (
<div className="container d-print-none">
<div className="row ">
    <div className="col-xs-12 col-sm-12 ">
        <div className="row noprint">
            <div className="col-sm-12 col-xs-12">
                <div className="row">
                    <div className="col-sm-10"></div>
                    <div className="col-sm-1 ">
                        <div className="text-center ">
                            <img className='rounded-circle' width='50' height="50" src={pageData.imgUrl} alt='UserImage'/>
                        </div>
                        <div className='caption text-center'>Welcome {pageData.userName}</div>
                    </div>
                    <div className="col-sm-1 pull-right">
                        <ul className=" nav nav-pills">
                            <li className="dropdown">
							    <a className="dropdown-toggle" role="button" data-bs-toggle="dropdown" href="#" aria-expanded="false" id="dropdownMenuLink">
								
                                    <img src="/assets/images/bars-solid.svg" alt='hamberger menu icon'/>
								</a>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                    <li>
									    <a className="btn btn-block" href="/changePassword" >
                                            Change Password
										</a>
									</li>
                                    <li>
									    <a className="btn btn-block pull-left" href="/logout" >
                                            <span className="glyphicon glyphicon-log-out"></span> Log out
										</a>
									</li>
                                </ul>
                            </li> 
                        </ul>
                    </div>
                </div>
			</div>
		</div>
	</div>	
</div>


</div>

);
}
export default header;